import './AccountDetailsTransactions.scss';

import { shape, string, arrayOf } from 'prop-types';
import React, { Fragment } from 'react';
import { transactions } from 'services/Externals';
import { isCollegeSavings, isMutualFund } from 'services/Products';
import { MoreButton } from 'components/shared/Buttons/GridCellButtons';
import { isRMDEligibleAccount } from 'services/AccountTypes';
import { Link } from 'react-router-dom';

const AccountDetailsTransactions = ({
  productType,
  transactionUrls,
  data,
  accountId,
  sweepAccountId,
  isMobile,
  isAccountDetails,
  isRMDEligible,
  accountTypeId
}) => {
  let buyButtonLink = ``;
  transactionUrls.map((transactionUrl) => {
    const { label, path } = transactionUrl;
    if (label === 'Buy') {
      buyButtonLink = path;
    }
  });

  const isRMDAccountDetails =
    isRMDEligible && isRMDEligibleAccount(accountTypeId);

  return (
    <div className="data-table transaction-buttons">
      <div>
        <span className="data-table-header">I want to...</span>
      </div>

      {isMutualFund(productType) && (
        <div className="mutual-fund-account-details">
          <div className="account-details-tile-buttons">
            <a className="buy-button-account-details" href={buyButtonLink}>
              Buy
            </a>
            <MoreButton
              data={data}
              accountId={accountId}
              sweepAccountId={sweepAccountId}
              productType={productType}
              isMobile={isMobile}
              isAccountDetails={isAccountDetails}
              isRMDEligible={isRMDAccountDetails}
            />
          </div>
          <div className="account-details-tile-links">
            <Link
              to={'/profile/beneficiaries'}
              className="account-details-link">
              Update Beneficiaries
            </Link>
            <Link
              to={'/profile/trusted-contacts'}
              className="account-details-link">
              Add/Update Trusted Contacts
            </Link>
            <Link
              to={'/profile/dividends-and-capital-gains'}
              className="account-details-link">
              Manage Dividends & Capital Gains
            </Link>
          </div>
        </div>
      )}
      {!isMutualFund(productType) && (
        <Fragment>
          {transactionUrls.map((transactionUrl, index) => {
            const { label, path } = transactionUrl;
            return (
              <a key={index} className="transaction-button" href={path}>
                {label}
              </a>
            );
          })}
          <a
            className="transaction-button automatic-transactions"
            href={
              isCollegeSavings(productType)
                ? transactions.collegeSavings.automaticMonthlyContributions
                : transactions.mutualFund.automaticTransactions
            }>
            {isCollegeSavings(productType)
              ? 'Manage Automatic Contributions'
              : 'Manage Automatic Transactions'}
          </a>
        </Fragment>
      )}
    </div>
  );
};

AccountDetailsTransactions.propTypes = {
  transactionUrls: arrayOf(
    shape({
      label: string.isRequired,
      path: string.isRequired
    })
  )
};

export default AccountDetailsTransactions;
